import $ from 'jquery';
import toastr from 'toastr';
import { I18n } from "i18n-js";
const i18n = new I18n();

$(document).ready(function () {
  var $selectPartnerConfig = $('.select-partner-config-js');
  var $selectSecretariesConfig = $('.select-secretaries-config-js');
  var $selectYearsConfig = $('.select-year-config-js');

  var $selectPartnerReport = $('.select-partner-report-js');
  var $selectSecretariesReport = $('.select-secretaries-report-js');
  var $selectYearsReport = $('.select-year-report-js');

  $selectPartnerConfig.change(function() {
    var selectSecretaries = '.select-secretaries-config-js';
    var selectYears = '.select-year-config-js';
    removeSecretaryOptions(selectSecretaries, selectYears);

    selectedSecretary('.select-partner-config-js', selectSecretaries, selectYears);
  });

  $selectPartnerReport.change(function() {
    var selectSecretaries = '.select-secretaries-report-js';
    var selectYears = '.select-year-report-js';
    removeSecretaryOptions(selectSecretaries, selectYears);

    var allOption = $("<option></option>")
      .attr('value', 'all')
      .text(i18n.t('views.reports.index.all_secretaries'));
    $('.select-secretaries-report-js option:first').after(allOption);

    selectedSecretary('.select-partner-report-js', selectSecretaries, selectYears);
  });

  $selectSecretariesConfig.change(function() {
    var selectYears = '.select-year-config-js';
    removeYearOptions(selectYears);

    selectedPartner('.select-partner-config-js', '.select-secretaries-config-js', selectYears);
  });

  $selectSecretariesReport.change(function() {
    var selectYears = '.select-year-report-js';
    removeYearOptions(selectYears);

    var allOption = $("<option></option>")
      .attr('value', 'all')
      .text(i18n.t('views.reports.index.all_school_years'));
    $('.select-year-report-js option:first').after(allOption);

    selectedPartner('.select-partner-report-js', '.select-secretaries-report-js', selectYears);
  });
});

function removeSecretaryOptions(selectSecretaries, selectYears) {
  $(selectSecretaries + ' option:not(:first)').remove();
  removeYearOptions(selectYears);
}

function removeYearOptions(selectYears) {
  $(selectYears +' option:not(:first)').remove();
}

function selectedSecretary(selectPartner, selectSecretary, selectYear) {
  var partnerId = $(selectPartner+' option:selected').val();
  if (partnerId) {
    selectPartnerSecretariesRequest(partnerId, selectSecretary, selectYear);
  }
}

function selectedPartner(selectPartner, selectSecretary, selectYears) {
  var secretaryId = $(selectSecretary+' option:selected').val();
  var partnerId = $(selectPartner+' option:selected').val();
  if (secretaryId && partnerId) {
    selectSecretariesSchoolYearRequest(partnerId, secretaryId, selectYears);
  }
}

function selectData(data, select) {
  $.each(data, function(key, value) {
    $(select)
      .append($("<option></option>")
        .attr("value", value[1])
        .text(value[0]));
  });
}

function yearSelectData(data, select) {
  $.each(data, function(key, value) {
    $(select)
      .append($("<option></option>")
        .attr("value", value)
        .text(value));
  });
}

function selectPartnerSecretariesRequest(partnerId, selectSecretaries, selectYears) {
  $.ajax({
    method: 'GET',
    url: '/api/v2/partners/'+partnerId+'/secretaries',
    dataType: 'json',
    success: function(data) {
      selectData(data, selectSecretaries);
    },
    error: function(data) {
      console.log(data);
      toastr.error(data.responseJSON.message);
    }
  });
}

function selectSecretariesSchoolYearRequest(partnerId, secretaryId, selectYears) {
  $.ajax({
    method: 'GET',
    url: '/api/v2/school_years',
    data: {
      secretary_id: secretaryId,
      partner_id: partnerId
    },
    dataType: 'json',
    success: function(data) {
      yearSelectData(data, selectYears);
    },
    error: function(data) {
      toastr.error(data.responseJSON.message);
    }
  });
}
